import React from "react";
import { Redirect, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { isAccessAllowed } from "../../../auth";
import APIComponent from "../../../components/API";
import ReservationsCalendarHeader from "./ReservationsCalendarHeader";
import core from "../../../vendors/core-api";
import ReservationsList from "./ReservationsList";
import moment from "moment";
import { DB_DATE_FORMAT, RESERVATION_COLOR } from "../../../constants";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import ReservationsDetails from "./ReservationsDetails";
import { Card } from "react-bootstrap";
import AddNotesModal from "./AddNotesModal";
import EditDietaryModal from "./EditDietaryModal";
import EditCelebrationModal from "./EditCelebrationModal";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { tryParse } from "../../../helpers";
import GuestInformationModal from "./GuestInformationModal";
import { Container, Modal } from "react-bootstrap";
import SmartReservationForm from "../../../partials/reservations/SmartReservationForm";
import {
  fetchReservableTablesData,
  buildTimeSlots,
  getIsTableFullyBooked,
  getTableUniqueExperience as getTableUniqueExperienceUtil,
  getPrunedSelectionsAfterPartySizeChange,
} from "../../../partials/reservations/reservationSlots";
import {
  createReservation,
  updateReservation,
  cancelReservation,
  seatReservation,
  finishReservation,
  seedCustomAmount,
} from "../../../partials/reservations/reservationsApi";
import { isReservationV2Enabled } from "../../../helpers/featureFlags";
import { getSeatingBlockedReason } from "../../../partials/reservations/seatingRules";

const INITIAL_VALUES = {
  reservation_date: moment().add(1, "days").format(DB_DATE_FORMAT),
  party_size: 4,
  experience: null,
  table: null,
  reservation_time: null,
  firstName: "",
  lastName: "",
  email: "",
  contact: "",
  dietary: [],
  otherDietaryNote: "",
  celebration: [],
  otherCelebrationNote: "",
  allowOverBooking: true,
  overrideReservableDays: true,
  additionals: [],
};

export default function Page() {
  const params = useParams(),
    { user } = useSelector((state) => state.auth),
    { brand_url = "", store_id = "" } = params;

  return isAccessAllowed(user, { brand_url, store_id }) ? (
    <ReservationsConsole id={store_id} />
  ) : (
    <Redirect to={"/error/error-v3"} />
  );
}

const MySwal = withReactContent(Swal);

export const RESERVATIONS_TAB_LIST = {
  OVERVIEW: "overview",
  RESERVATIONS_QUEUE: "reservations",
  TASKS: "tasks",
  GUESTS: "guests",
  PENDING: "pending",
};

class ReservationsConsole extends APIComponent {
  constructor(props) {
    super(props);
    const store_id = this.props.id;
    this.state = {
      store_id,
      selected_date: moment().format(DB_DATE_FORMAT),
      selected_reservation: null,
      selected_customer: null,
      isReservationDetails: false,
      list_selected: RESERVATIONS_TAB_LIST.RESERVATIONS_QUEUE,
      guest_tags: [],
      reservation_notes: [],
      showNotesModal: false,
      refresh_list: false,
      showEditCelebrationModal: false,
      showEditDietaryModal: false,
      showModal: false,
      reservableTables: [],
      allReservableTables: [],
      showGuestInfoModal: false,
      selectedGuestForModal: null,

      /** Form related states ported from ReservationsCalendarHeader */
      isAdding: false,
      isDeleting: false,
      allTables: [],
      values: { ...INITIAL_VALUES },
      errors: {},
      touched: {},
      monthlyReservations: [],
      withPaymentLink: false,
    };

    this.data_url = "/store/" + store_id + "/header-details";
    this.api = core("pu").get();
    this.reservationsListRef = React.createRef();

    // Bind form-related methods
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.setFieldValue = this.setFieldValue.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.isFormOk = this.isFormOk.bind(this);
    this.isTouched = this.isTouched.bind(this);
    this.handleFeedbackError = this.handleFeedbackError.bind(this);
  }

  // --- Form Helper Methods ---
  handleOnChange = (event) => {
    const target = event.target,
      value = target.value,
      name = target.name;
    let { values } = this.state;
    values[name] = value;
    this.setState({ values: values });
    this.setStateKey("touched", name, true);
    this.validateForm();
  };

  handleOnBlur = (event) => {
    const target = event.target,
      name = target.name;
    this.setStateKey("touched", name, true);
    this.validateForm();
  };

  setStateKey = (statekey, key, value) => {
    let k = this.state[statekey];
    k[key] = value;
    let params = {};
    params[statekey] = k;
    this.setState(params);
  };

  setFieldValue = (field, value) => {
    this.setStateKey("values", field, value);
  };

  validateForm = async () => {
    // Basic validation for now, can be expanded if needed
    return {};
  };

  isFormOk = () => true;

  isTouched = (name) => {
    return this.getStateKeyValue("touched", name);
  };

  getStateKeyValue = (statekey, key) => {
    return this.state[statekey] && this.state[statekey][key];
  };

  handleFeedbackError = (field_name = "", type = "helper-text") => {
    const { errors = {} } = this.state;
    if (type === "helper-text") {
      return errors.hasOwnProperty(field_name) ? (
        <div className="invalid-feedback">{errors[field_name]}</div>
      ) : (
        <></>
      );
    } else if (type === "input") {
      return errors.hasOwnProperty(field_name) ? "is-invalid" : "";
    } else if (type === "error-text") {
      return errors[field_name];
    }
  };
  // --- End Form Helper Methods ---

  handleOnDataFetched = () => {
    const { data = {} } = this.state,
      { name = "", brand_name = "" } = data;
    this.setState({
      store_name: name,
      brand_name,
    });
  };

  async componentDidMount() {
    this._isMounted = true;
    await this.getData();
  }

  onCalendarBtnClick = (goNext = true) => {
    const { selected_date } = this.state;
    this.setState({
      selected_date: goNext
        ? moment(selected_date).add(1, "day").format(DB_DATE_FORMAT)
        : moment(selected_date).subtract(1, "day").format(DB_DATE_FORMAT),
    });
  };

  onDateInputChange = (e) => {
    this.setState({
      selected_date: e.target.value,
    });
  };

  onDayClick = (date) => {
    this.setState({
      selected_date: moment(date).format(DB_DATE_FORMAT),
    });
  };

  onReservationClick = async (reservation) => {
    let customer = null;
    if (reservation.partner_identifier && reservation.partner_identifier._id) {
      const { data } = await this.api.get(
        `/customer/${reservation.partner_identifier._id}`,
      );
      customer = data;
    }
    this.getReservationNotes(reservation);
    this.setState({
      selected_reservation: reservation,
      selected_customer: customer,
      guest_tags: customer?.tags || [],
      isReservationDetails: true,
    });
  };

  getReservationNotes = async (reservation) => {
    const partnerId =
      reservation?.partner_identifier?._id || reservation?.partner_identifier;

    if (partnerId && typeof partnerId === "string") {
      try {
        const orderId = reservation?._id;
        const query = orderId ? `?orderId=${orderId}` : "";
        const { data } = await this.api.get(
          `/reservation/${partnerId}/notes${query}`,
        );
        this.setState({ reservation_notes: data || [] });
      } catch (error) {
        console.error("Failed to fetch reservation notes:", error);
        this.setState({ reservation_notes: [] });
      }
    } else {
      this.setState({ reservation_notes: [] });
    }
  };

  onDetailsCloseClick = () => {
    this.setState({
      selected_reservation: null,
      selected_customer: null,
      isReservationDetails: false,
    });
  };

  onTabChange = () => {
    this.setState({
      selected_reservation: null,
      selected_customer: null,
      isReservationDetails: false,
    });
  };

  onListTabChange = (tab) => {
    this.setState({ list_selected: tab });
  };

  onRefreshList = () => {
    this.setState((prevState) => ({
      refresh_list: !prevState.refresh_list,
    }));
  };

  onAddNotesClick = () => {
    this.setState((prevState) => ({
      showNotesModal: !prevState.showNotesModal,
    }));
  };

  onEditDietaryClick = () => {
    this.setState((prevState) => ({
      showEditDietaryModal: !prevState.showEditDietaryModal,
    }));
  };

  onEditCelebrationClick = () => {
    this.setState((prevState) => ({
      showEditCelebrationModal: !prevState.showEditCelebrationModal,
    }));
  };

  onEditReservationClick = () => {
    const { selected_reservation } = this.state;
    if (!selected_reservation) return;

    this.handleReservationSelect(selected_reservation);
  };

  onGuestReservationClick = (reservation) => {
    this.onReservationClick(reservation);
    this.onListTabChange(RESERVATIONS_TAB_LIST.RESERVATIONS_QUEUE);
  };

  onCustomerNameClick = (customer) => {
    this.setState({
      showGuestInfoModal: true,
      selectedGuestForModal: customer,
    });
  };

  handleShowModal = () => {
    const { selected_date } = this.state;
    this.fetchAllTables();
    this.setState(
      (prevState) => ({
        showModal: true,
        values: { ...prevState.values, reservation_date: selected_date },
      }),
      () => {
        this.fetchReservableTables();
        this.refetchReservationByDate(this.state.values.reservation_date);
      },
    );
  };

  handleCloseModal = (callback) => {
    this.setState(
      {
        showModal: false,
        values: { ...INITIAL_VALUES },
      },
      () => {
        this.fetchAllTables();
        if (typeof callback === "function") callback();
      },
    );
  };

  fetchAllTables = async () => {
    const { store_id } = this.state;

    if (!store_id) return;
    try {
      const { data } = await this.api.get(
        `/branded-website/stores/${store_id}/reservable-tables`,
      );

      this.setState({ allTables: data.store_tables || [] });
    } catch (error) {
      console.error("Failed to fetch all tables:", error);
    }
  };

  fetchReservableTables = async () => {
    const { store_id } = this.state;
    const {
      reservation_date,
      party_size,
      overrideReservableDays,
      overrideTableCapacity,
    } = this.state.values;

    this.setState({ loading: true });
    try {
      const { reservableTables, allReservableTables } =
        await fetchReservableTablesData({
          api: this.api,
          store_id,
          reservation_date,
          party_size,
          override_reservable_days: overrideReservableDays !== false,
          override_table_capacity: overrideTableCapacity,
        });
      if (
        getIsTableFullyBooked(
          this.state.values.table,
          this.state.values.reservation_time,
          reservableTables,
        )
      ) {
        this.setFieldValue("allowOverBooking", true);
      }
      this.setState({ reservableTables, allReservableTables });
      return { reservableTables, allReservableTables };
    } catch (error) {
      console.error("Failed to fetch reservable tables:", error);
      this.setState({ reservableTables: [], allReservableTables: [] });
      return { reservableTables: [], allReservableTables: [] };
    } finally {
      this.setState({ loading: false });
    }
  };

  fetchCalendarReservations = async (fetchInfo, successCallback) => {
    const { store_id } = this.state;
    const start = moment(fetchInfo.startStr).format(DB_DATE_FORMAT);
    const end = moment(fetchInfo.endStr).format(DB_DATE_FORMAT);

    try {
      const { data } = await this.api.get(
        `/reservation/store/${store_id}/date-range?startDate=${start}&endDate=${end}`,
      );

      const allReservationsForMonth = Object.values(data)
        .flat()
        .filter((res) => !res.status?.toLowerCase().includes("cancelled"));

      this.setState({ monthlyReservations: allReservationsForMonth });
      if (successCallback) successCallback([]);
    } catch (error) {
      console.error("Failed to fetch calendar reservations:", error);
    }
  };

  handleReservationSelect = (reservation) => {
    if (!reservation) return;

    const table = reservation.order_details.find(
      (od) => od.item.type === "reservation",
    );
    const experience = reservation.order_details.find(
      (od) => od.item.type === "reservation_experience",
    );
    const addonItems = (reservation.order_details || []).filter(
      (od) => od.item && od.item.type === "reservation_addons",
    );
    const originalNotes = tryParse(reservation.notes) || {};

    this.setState(
      {
        selected_reservation: reservation,
        withPaymentLink: reservation.payment?.status === "pending",
        selected_date: reservation.order_date,
        values: {
          overrideReservableDays: true,
          allowOverBooking: true,
          reservation_date: moment(reservation.order_date).format(
            DB_DATE_FORMAT,
          ),
          party_size: experience ? experience.qty : 1,
          experience: experience ? experience.item._id : null,
          table: table ? table.item._id : null,
          reservation_time: reservation.order_time,
          firstName: reservation.guest_customer.first_name,
          lastName: reservation.guest_customer.last_name,
          email: reservation.guest_customer.email,
          contact: reservation?.guest_customer?.contact_number ?? "",
          dietary: originalNotes.dietary || [],
          celebration: originalNotes.celebration || [],
          additionals: addonItems.map((od) => ({
            label: od.item?.name || od.name,
            amount: Number(od.item?.price ?? od.price) || 0,
          })),
          // Mirrored onto the Order regardless of v1/v2 mode (see
          // helpers/reservation.js's reservation_notes mirror) — seeded here
          // so re-opening an already-overridden reservation for editing
          // shows its current custom price/override instead of silently
          // reverting them to the computed default on save.
          customAmount: seedCustomAmount(reservation.reservation_notes),
          overrideTableCapacity: Boolean(
            reservation.reservation_notes?.party_size_override,
          ),
        },
      },
      () => {
        this.handleShowModal();
      },
    );
  };

  handleCancelReservation = async () => {
    if (this.state.selected_reservation) {
      try {
        await this.onStatusChange(
          "cancelled",
          this.state.values.table,
          this.state.selected_reservation,
        );
        const { reservation_date } = this.state.values;
        this.setState({
          values: { ...INITIAL_VALUES, reservation_date },
          showModal: false,
        });
        this.props.onRefreshList();
      } catch (error) {
        // The error is already handled or shown
      }
    }
  };

  handleDateChange = (e) => {
    const newDate = e.target.value;
    const isEditMode = !!this.state.selected_reservation;

    if (isEditMode) {
      // Edit mode: only update the date, preserve all other selections
      this.setState(
        (prevState) => ({
          values: {
            ...prevState.values,
            reservation_date: newDate,
          },
        }),
        () => {
          this.fetchReservableTables();
        },
      );
    } else {
      // Create mode: reset all selections for the new date
      this.setState(
        {
          values: {
            ...INITIAL_VALUES,
            reservation_date: newDate,
          },
          selected_reservation: null,
        },
        () => {
          this.fetchReservableTables();
        },
      );
    }
  };

  handlePartySizeChange = (amount) => {
    const { uniqueExperiences, values } = this.state;
    const selectedExperienceDetails = uniqueExperiences?.find(
      (exp) => exp._id === values?.experience,
    );
    if (selectedExperienceDetails?.isExclusive && amount > 0) {
      return;
    }
    const currentSize = this.state.values.party_size;
    const newSize = Math.max(1, currentSize + amount);
    this.setState(
      (prevState) => ({
        values: {
          ...prevState.values,
          party_size: newSize,
        },
      }),
      async () => {
        const fetchedTables = await this.fetchReservableTables();
        this.pruneSelectionsInvalidatedByPartySize(fetchedTables);
      },
    );
  };

  // After a party-size refetch, keep the previously selected time/table/experience
  // unless they no longer exist in the freshly fetched availability data.
  // Takes the freshly fetched tables as an argument rather than reading them
  // off this.state, since setState is not guaranteed to have flushed yet.
  // Shared with ReservationsCalendarHeader via getPrunedSelectionsAfterPartySizeChange.
  pruneSelectionsInvalidatedByPartySize = ({
    reservableTables = [],
    allReservableTables = [],
  } = {}) => {
    const { values } = this.state;
    const nextSelections = getPrunedSelectionsAfterPartySizeChange({
      reservableTables,
      allReservableTables,
      values,
    });

    if (!nextSelections) return;

    this.setState((prevState) => ({
      values: { ...prevState.values, ...nextSelections },
    }));
  };

  refetchReservationByDate = async (reservation_date) => {
    await this.fetchCalendarReservations({
      startStr: moment(reservation_date).startOf("month").format(),
      endStr: moment(reservation_date).endOf("month").format(),
    });
  };

  handleCreateReservation = async () => {
    const { store_id } = this.state;
    const {
      reservation_date,
      party_size,
      experience,
      reservation_time,
      firstName,
      lastName,
      email,
      contact,
      table,
      dietary,
      celebration,
      allowOverBooking,
      overrideReservableDays,
      additionals,
      customAmount,
      overrideTableCapacity,
      payInPerson,
    } = this.state.values;

    const normalizedContact = (contact || "").trim();

    this.setState({ isAdding: true });

    if (this.state.selected_reservation) {
      // Editing existing reservation
      const payload = {
        notes: {
          dietary: dietary,
          celebration: celebration,
        },
        reservation: this.state.selected_reservation,
        order_date: reservation_date,
        order_time: reservation_time,
        table_id: table,
        experience_id: experience,
        party_size,
        firstName,
        lastName,
        email,
        contact: normalizedContact,
        allowOverBooking: allowOverBooking,
        overrideReservableDays: overrideReservableDays !== false,
        additionals: additionals || [],
        customAmount,
        overrideTableCapacity,
        payInPerson,
      };

      await this.onEditReservationSubmit(
        payload,
        () => {
          this.setState(
            {
              isAdding: false,
              values: { ...INITIAL_VALUES, reservation_date },
            },
            async () => {
              this.fetchReservableTables();
              await this.refetchReservationByDate(reservation_date);
            },
          );
        }, // Pass a function to be called when done
        true, // Close modal
      );
    } else {
      // This is for creating a new reservation
      try {
        await createReservation(this.api, store_id, {
          firstName,
          lastName,
          email,
          contact: normalizedContact,
          tableId: table,
          experienceId: experience,
          partySize: party_size,
          reservationDate: reservation_date,
          reservationTime: reservation_time,
          notes: {
            dietary: dietary,
            celebration: celebration,
          },
          withPaymentLink: this.state.withPaymentLink,
          allow_overbooking: allowOverBooking !== false,
          override_reservable_days: overrideReservableDays !== false,
          additionals: additionals || [],
          // v2-only — stripped by reservationsApi when the flag is off.
          custom_amount:
            this.state.values.customAmount !== "" &&
            this.state.values.customAmount !== undefined
              ? Number(this.state.values.customAmount)
              : undefined,
          override_table_capacity: this.state.values.overrideTableCapacity,
        });

        MySwal.fire({
          icon: "success",
          title: "Reservation Added!",
          timer: 1500,
          showConfirmButton: false,
        });

        this.setState(
          {
            values: { ...INITIAL_VALUES, reservation_date },
            selected_reservation: null,
            showModal: false,
            refresh_list: !this.state.refresh_list,
          },
          async () => {
            this.fetchReservableTables();
            await this.refetchReservationByDate(reservation_date);
          },
        );
      } catch (error) {
        console.error("Failed to create reservation:", error);
      } finally {
        this.setState({ isAdding: false });
      }
    }
  };

  handleAddAdditional = (item) => {
    const current = this.state.values.additionals || [];
    this.setFieldValue("additionals", [...current, item]);
  };

  handleRemoveAdditional = (index) => {
    const { selected_reservation, values } = this.state;
    const isPending =
      selected_reservation?.payment?.status === "pending" ||
      selected_reservation?.payment?.status === "failed";
    const isPaidStatus = selected_reservation?.payment?.status === "paid";
    const paidAmount =
      isPending || !isPaidStatus
        ? 0
        : Number(selected_reservation?.payment?.amount || 0);
    if (paidAmount > 0) {
      const experience = (selected_reservation?.order_details || []).find(
        (od) => od.item && od.item.type === "reservation_experience",
      );
      const experienceSubtotal =
        (experience?.price || 0) * (values.party_size || experience?.qty || 1);
      let remainingPaid = Math.max(0, paidAmount - experienceSubtotal);
      const additionals = values.additionals || [];
      for (let i = 0; i < additionals.length; i++) {
        const itemAmount = Number(additionals[i].amount) || 0;
        const isItemPaid = remainingPaid >= itemAmount && itemAmount > 0;
        if (isItemPaid) {
          remainingPaid -= itemAmount;
        }
        if (i === index && isItemPaid) {
          return;
        }
      }
    }
    const current = values.additionals || [];
    this.setFieldValue(
      "additionals",
      current.filter((_, i) => i !== index),
    );
  };

  handlePillClick = (field, value) => {
    if (field === "table") {
      const currentTable = this.state.values.table;
      const newTable = currentTable === value._id ? null : value._id;
      this.setFieldValue("table", newTable);
      this.setFieldValue("experience", null);
      return;
    } else {
      this.setFieldValue(
        field,
        this.state.values[field] === value ? null : value,
      );
    }
  };

  handleDietaryPillClick = (itemName) => {
    const { values } = this.state;
    const currentItems = [...(values.dietary || [])];

    const existingItemIndex = currentItems.findIndex(
      (item) => item.label.toLowerCase() === itemName.toLowerCase(),
    );

    let newItems;
    if (existingItemIndex > -1) {
      newItems = currentItems.filter(
        (item) => item.label.toLowerCase() !== itemName.toLowerCase(),
      );
    } else {
      newItems = [...currentItems, { label: itemName, count: 1 }];
    }
    this.setFieldValue("dietary", newItems);
  };

  handleUpdateDietaryCount = (itemName, newCount) => {
    const { values } = this.state;
    let newItems;
    if (newCount < 1) {
      newItems = (values.dietary || []).filter(
        (item) => item.label.toLowerCase() !== itemName.toLowerCase(),
      );
    } else {
      newItems = (values.dietary || []).map((item) =>
        item.label.toLowerCase() === itemName.toLowerCase()
          ? { ...item, count: newCount }
          : item,
      );
    }
    this.setFieldValue("dietary", newItems);
  };

  handleAddCustomDietaryItem = () => {
    const { values } = this.state;
    const itemName = (values.otherDietaryNote || "").trim();
    if (!itemName) return;

    const itemExists = (values.dietary || []).some(
      (item) => item.label.toLowerCase() === itemName.toLowerCase(),
    );

    if (itemExists) {
      this.setFieldValue("otherDietaryNote", "");
      return;
    }

    const newItems = [...(values.dietary || []), { label: itemName, count: 1 }];
    this.setFieldValue("dietary", newItems);
    this.setFieldValue("otherDietaryNote", "");
  };

  handlewithPaymentLinkChange = (e) =>
    this.setState({ withPaymentLink: e.target.checked });

  handleCelebrationPillClick = (itemName) => {
    const { values } = this.state;
    const currentItems = [...(values.celebration || [])];
    const existingItemIndex = currentItems.findIndex(
      (item) => item.label.toLowerCase() === itemName.toLowerCase(),
    );

    let newItems;
    if (existingItemIndex > -1) {
      newItems = currentItems.filter(
        (item) => item.label.toLowerCase() !== itemName.toLowerCase(),
      );
    } else {
      newItems = [...currentItems, { label: itemName, count: 1 }];
    }

    this.setFieldValue("celebration", newItems);
  };

  handleAddCustomCelebrationItem = () => {
    const { values } = this.state;
    const itemName = (values.otherCelebrationNote || "").trim();
    if (!itemName) return;

    const itemExists = (values.celebration || []).some(
      (item) => item.label.toLowerCase() === itemName.toLowerCase(),
    );

    if (itemExists) {
      this.setFieldValue("otherCelebrationNote", "");
      return;
    }

    const newItems = [
      ...(values.celebration || []),
      { label: itemName, count: 1 },
    ];
    this.setFieldValue("celebration", newItems);
    this.setFieldValue("otherCelebrationNote", "");
  };
  handleExclusiveExperiencePillClick = (experienceId) => {
    this.setFieldValue("experience", experienceId);
    this.setState((prevState) => ({
      values: { ...prevState.values, party_size: 1 },
    }));
  };

  getModalMode = () => {
    const { selected_reservation } = this.state;
    if (!selected_reservation) return "create";
    return "update";
  };

  handleResendEmail = async () => {
    const { selected_reservation } = this.state;
    if (!selected_reservation) return;

    this.setState({ isAdding: true });
    try {
      await this.api.post({
        url: `/reservation/${selected_reservation._id}/resend-payment-link`,
      });
      MySwal.fire({
        toast: true,
        icon: "success",
        title: "Payment link resent!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Failed to resend payment link:", error);
      MySwal.fire({
        icon: "error",
        title: "Error",
        text: "Could not resend the payment link. Please try again.",
      });
    } finally {
      this.setState({ isAdding: false });
    }
  };
  onEditReservationSubmit = async (values, onDone, closeModal = true) => {
    // Accept reservation object directly, fallback to state for other call sites
    const reservationToUpdate =
      values.reservation || this.state.selected_reservation;

    if (!reservationToUpdate) return;

    const {
      order_date,
      order_time,
      table_id,
      experience_id,
      party_size,
      notes,
      firstName,
      lastName,
      email,
      contact,
      allowOverBooking,
      overrideReservableDays,
      additionals,
      customAmount,
      overrideTableCapacity,
      payInPerson,
    } = values;
    const v2 = isReservationV2Enabled();
    try {
      // This is the endpoint for moving/updating reservation details like date, time, table.
      const { order: updatedReservation, paymentLink } =
        await updateReservation(this.api, reservationToUpdate._id, {
          order_date,
          order_time,
          newTable: table_id,
          newExperience: experience_id,
          party_size,
          notes: JSON.stringify(notes),
          first_name: firstName,
          last_name: lastName,
          email: email,
          contact_number: contact,
          allow_overbooking: allowOverBooking !== false,
          override_reservable_days: overrideReservableDays !== false,
          additionals: additionals || [],
          // v2-only — stripped by reservationsApi when the flag is off.
          custom_amount:
            customAmount !== "" && customAmount !== undefined
              ? Number(customAmount)
              : undefined,
          override_table_capacity: overrideTableCapacity,
          pay_in_person: payInPerson,
        });
      if (closeModal) {
        this.setState({
          // v2's response shape (a Reservation, not the Order) differs
          // enough from v1's that merging it into selected_reservation
          // would be misleading — refetch the list instead and let the
          // console pick the fresh Order up from there. isReservationDetails
          // must go false in the same update: every other call site that
          // nulls selected_reservation (onDetailsCloseClick, onTabChange)
          // does the same, since the details pane renders
          // reservation.status/reservation.partner_identifier unguarded and
          // crashes on a null reservation otherwise.
          selected_reservation: v2
            ? null
            : {
                ...reservationToUpdate,
                ...updatedReservation,
              },
          ...(v2 && { isReservationDetails: false }),
          showModal: false,
          refresh_list: !this.state.refresh_list,
        });
      }
      if (paymentLink) {
        // Awaited, and the plain success toast below is skipped when this
        // fires: both use the same SweetAlert2 singleton popup, so an
        // un-awaited second fire() replaces this one before the admin can
        // read or copy the link.
        await MySwal.fire({
          icon: "info",
          title: "Payment required",
          html: `A payment link was created for the price difference. Share it with the guest:<br/><br/><code style="user-select:all;">${paymentLink}</code>`,
        });
      } else {
        MySwal.fire({
          toast: true,
          icon: "success",
          title: "Reservation updated!",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    } catch (err) {
      console.error(err);
      const errorMessage =
        err.response?.data?.error_message ||
        "Could not update the reservation.";
      MySwal.fire("Error!", errorMessage, "error");
    } finally {
      if (onDone) onDone();
    }
  };

  onSubmitNotes = async (value) => {
    const { selected_reservation } = this.state;
    if (!selected_reservation) return;

    const rawPartnerId =
      selected_reservation.partner_identifier?._id ||
      selected_reservation.partner_identifier;
    const partnerId = typeof rawPartnerId === "string" ? rawPartnerId : null;

    const payload = {
      order_id: selected_reservation._id,
      note: value.notes,
      date: selected_reservation.order_date,
      storeId: selected_reservation.store,
      action: "add",
      partnerId: partnerId,
    };

    try {
      await this.api.put({
        url: `/reservation/${selected_reservation._id}/notes`,
        data: payload,
      });

      // Refetch notes to get the latest list
      await this.getReservationNotes(selected_reservation);

      this.onAddNotesClick(); // Close modal
      MySwal.fire({
        toast: true,
        icon: "success",
        title: "Note successfully added!",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error("Failed to add note:", err);
      MySwal.fire("Error!", "Could not add the note.", "error");
    }
  };

  onEditCelebrationSubmit = async (values, setSubmitting) => {
    const { selected_reservation } = this.state;
    if (!selected_reservation) return;

    setSubmitting(true);

    const currentNotes = tryParse(selected_reservation.notes) || {};
    const newNotesPayload = {
      ...currentNotes,
      celebration: values.celebration,
    };

    try {
      const { data: updatedReservation } = await this.api.put({
        url: `reservation/${selected_reservation._id}`,
        data: { notes: JSON.stringify(newNotesPayload) },
      });

      this.setState({
        selected_reservation: updatedReservation,
        showEditCelebrationModal: false,
      });

      MySwal.fire({
        toast: true,
        icon: "success",
        title: "Celebrations updated!",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error(err);
      MySwal.fire("Error!", "Could not update celebrations.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  onEditDietarySubmit = async (values, setSubmitting) => {
    const { selected_reservation } = this.state;
    if (!selected_reservation) return;

    setSubmitting(true);

    const currentNotes = tryParse(selected_reservation.notes) || {};
    const newNotesPayload = {
      ...currentNotes,
      dietary: values.dietary,
    };

    try {
      const { data: updatedReservation } = await this.api.put({
        url: `reservation/${selected_reservation._id}`,
        data: { notes: JSON.stringify(newNotesPayload) },
      });

      this.setState({
        selected_reservation: updatedReservation,
        showEditDietaryModal: false,
      });

      MySwal.fire({
        toast: true,
        icon: "success",
        title: "Dietary notes updated!",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error(err);
      MySwal.fire("Error!", "Could not update dietary notes.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  onNoteUpdate = async (orderId, noteId, newText) => {
    const { selected_reservation } = this.state;
    if (!selected_reservation) return;

    const targetOrderId =
      newText !== undefined ? orderId : selected_reservation._id;
    const targetNoteId = newText !== undefined ? noteId : orderId;
    const targetText = newText !== undefined ? newText : noteId;

    const rawPartnerId =
      selected_reservation.partner_identifier?._id ||
      selected_reservation.partner_identifier;
    const partnerId = typeof rawPartnerId === "string" ? rawPartnerId : null;

    const payload = {
      order_id: targetOrderId,
      noteId: targetNoteId,
      note: targetText,
      date: selected_reservation.order_date,
      storeId: selected_reservation.store,
      action: "update",
      partnerId: partnerId,
    };

    try {
      await this.api.put({
        url: `/reservation/${targetOrderId}/notes`,
        data: payload,
      });
      await this.getReservationNotes(selected_reservation);
    } catch (err) {
      console.error("Failed to update note:", err);
      MySwal.fire("Error!", "Could not update the note.", "error");
    }
  };

  onNoteDelete = async (orderId, noteId) => {
    const { selected_reservation } = this.state;
    if (!selected_reservation) return;

    const targetOrderId = noteId ? orderId : selected_reservation._id;
    const targetNoteId = noteId || orderId;

    const result = await MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: RESERVATION_COLOR,
      cancelButtonColor: "#F64E60",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      const rawPartnerId =
        selected_reservation.partner_identifier?._id ||
        selected_reservation.partner_identifier;
      const partnerId = typeof rawPartnerId === "string" ? rawPartnerId : null;

      const payload = {
        order_id: targetOrderId,
        noteId: targetNoteId,
        note: null,
        date: selected_reservation.order_date,
        storeId: selected_reservation.store,
        action: "delete",
        partnerId: partnerId,
      };

      try {
        await this.api.put({
          url: `/reservation/${targetOrderId}/notes`,
          data: payload,
        });
        await this.getReservationNotes(selected_reservation);
        MySwal.fire("Deleted!", "The note has been deleted.", "success");
      } catch (err) {
        console.error("Failed to delete note:", err);
        MySwal.fire("Error!", "Could not delete the note.", "error");
      }
    }
  };

  onAddTags = async (e, values) => {
    e.preventDefault();
    const { selected_customer } = this.state;
    if (!selected_customer) return;

    try {
      await this.api.put({
        url: `/customer/${selected_customer._id}/tags`,
        data: { tags: values },
      });
      this.setState({ guest_tags: values });
      MySwal.fire({
        toast: true,
        icon: "success",
        title: "Tags updated!",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      MySwal.fire("Error!", "Could not update tags.", "error");
    }
  };

  onStatusChange = (status, assigned_table, reservation) => {
    const reservationToUpdate = reservation || this.state.selected_reservation;

    if (status === "seated" || status === "finished") {
      const reason = getSeatingBlockedReason(reservationToUpdate, status);
      if (reason) {
        const isSeated = status === "seated";
        return MySwal.fire({
          title: isSeated
            ? "Cannot Seat Reservation"
            : "Cannot Finish Reservation",
          text: reason,
          icon: "warning",
          confirmButtonColor: RESERVATION_COLOR,
        });
      }
    }

    const statusMap = {
      seated: "accepted",
      finished: "completed",
      cancelled: "cancelled",
    };

    const dbStatus = statusMap[status];
    const confirmButtonText =
      dbStatus === "cancelled" ? "Cancel Reservation" : "Yes, Proceed!";
    return MySwal.fire({
      title: "Are you sure?",
      text: `You are about to mark this reservation as "${status}".`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      confirmButtonColor: RESERVATION_COLOR,
      cancelButtonText: "Go Back",
      cancelButtonColor: "#b7b3b3ff",
      reverseButtons: true,
      customClass: {
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        let tableToAssign = assigned_table;
        if (!tableToAssign) {
          if (
            reservationToUpdate.order_details &&
            reservationToUpdate.order_details.length > 0
          ) {
            const reservationItem = reservationToUpdate.order_details.find(
              (detail) => detail.item.type === "reservation",
            );
            if (reservationItem) {
              tableToAssign = reservationItem.item._id;
            }
          }
        }

        try {
          let result;
          if (status === "seated") {
            result = await seatReservation(this.api, reservationToUpdate._id, {
              tableId: tableToAssign,
            });
          } else if (status === "finished") {
            result = await finishReservation(this.api, reservationToUpdate._id);
          } else if (status === "cancelled") {
            result = await cancelReservation(this.api, reservationToUpdate._id);
          }

          if (result?.order) {
            MySwal.fire({
              toast: true,
              icon: "success",
              title: "The reservation status has been updated!",
              timer: 1500,
              showConfirmButton: false,
            }).then(() => {
              this.onDetailsCloseClick();
              this.setState((prevState) => ({
                refresh_list: !prevState.refresh_list,
              }));
            });
          }
        } catch (err) {
          const errorMessage =
            err.response?.data?.error_message ||
            "Could not update the reservation status.";
          MySwal.fire("Error!", errorMessage, "error");
        }
      }
    });
  };

  getTableUniqueExperience = (tableId) =>
    getTableUniqueExperienceUtil({
      tableId,
      allReservableTables: this.state.allReservableTables,
      reservationTime: this.state.values.reservation_time,
    });

  render() {
    const {
      selected_date,
      store_id,
      selected_customer,
      selected_reservation,
      isReservationDetails,
      reservation_notes,
      guest_tags,
      showNotesModal,
      showEditCelebrationModal,
      showEditDietaryModal,
      reservableTables,
      allReservableTables,
      list_selected,
      refresh_list,
      store_name,
      showGuestInfoModal,
      selectedGuestForModal,
      showModal,
      values,
      isAdding,
      isDeleting,
      monthlyReservations,
      withPaymentLink,
      loading,
    } = this.state;

    const selectedTable = reservableTables.find(
      (t) => t.item._id === values.table,
    );

    const uniqueExperiences = this.getTableUniqueExperience(values.table);

    if (selected_reservation) {
      const originalExperience = selected_reservation.order_details.find(
        (od) => od.item?.type === "reservation_experience",
      )?.item;

      const originalTableId = selected_reservation.order_details.find(
        (od) => od.item?.type === "reservation",
      )?.item?._id;

      if (originalExperience && values.table === originalTableId) {
        const isOriginalExperienceInList = uniqueExperiences.some(
          (exp) => exp._id === originalExperience._id,
        );
        if (!isOriginalExperienceInList) {
          uniqueExperiences.push(originalExperience);
        }
      }
    }

    const allTimeSlots = buildTimeSlots({
      reservableTables,
      allReservableTables,
    });

    let tablesForSelectedTime = values.reservation_time ? reservableTables : [];

    if (selected_reservation && values.reservation_time) {
      const originalTableId = selected_reservation.order_details.find(
        (od) => od.item?.type === "reservation",
      )?.item?._id;

      if (originalTableId) {
        const isOriginalTableInList = tablesForSelectedTime.some(
          (t) => t.item._id === originalTableId,
        );
        if (!isOriginalTableInList) {
          const originalTableFromAll = reservableTables.find(
            (t) => t.item._id === originalTableId,
          );
          if (originalTableFromAll)
            tablesForSelectedTime.push(originalTableFromAll);
        }
      }
    }

    const inputActions = {
      onChange: this.handleOnChange,
      onBlur: this.handleOnBlur,
    };

    const isFullWidthView =
      list_selected === RESERVATIONS_TAB_LIST.OVERVIEW ||
      list_selected === RESERVATIONS_TAB_LIST.GUESTS;

    return (
      <>
        {showNotesModal && (
          <AddNotesModal
            show={showNotesModal}
            onHide={this.onAddNotesClick}
            onSubmit={this.onSubmitNotes}
          />
        )}
        {showEditCelebrationModal && (
          <EditCelebrationModal
            show={showEditCelebrationModal}
            onHide={this.onEditCelebrationClick}
            onSubmit={this.onEditCelebrationSubmit}
            reservation={selected_reservation}
          />
        )}
        {showEditDietaryModal && (
          <EditDietaryModal
            show={showEditDietaryModal}
            onHide={this.onEditDietaryClick}
            onSubmit={this.onEditDietarySubmit}
            reservation={selected_reservation}
          />
        )}
        {showModal && (
          <Modal
            dialogClassName="modal-90w"
            show={showModal}
            size="xl"
            onHide={this.handleCloseModal}
            centered
          >
            <style>
              {`
              .modal-90w {
                max-width: 80vw !important;
              }
              .selected-reservation-date {
                background-color: ${RESERVATION_COLOR} !important;
                color: white !important;
                border: 3px solid ${RESERVATION_COLOR} !important;
                font-weight: bold;
                border-radius: 4px; /* Optional: for rounded corners */
              }
              .selected-reservation-date .fc-daygrid-day-number {
                color: white !important;
              }
              /* Theme FullCalendar Buttons */
              .fc .fc-button-primary {
                background-color: ${RESERVATION_COLOR} !important;
                border-color: ${RESERVATION_COLOR} !important;
                box-shadow: none !important;
                font-weight: 700 !important;
                text-transform: uppercase !important;
                font-size: 0.8rem !important;
                transition: all 0.2s ease !important;
              }
              .fc .fc-button-primary:hover {
                background-color: ${RESERVATION_COLOR}dd !important;
                border-color: ${RESERVATION_COLOR}dd !important;
                transform: translateY(-1px);
              }
              .fc .fc-button-primary:disabled {
                background-color: #ebedf3 !important;
                border-color: #ebedf3 !important;
                color: #b5b5c3 !important;
              }
              .fc .fc-toolbar-title {
                font-size: 1.25rem !important;
                font-weight: 800 !important;
                color: #3f4254 !important;
                text-transform: uppercase;
                letter-spacing: 0.5px;
              }
              /* Global Modal Button Overrides */
              .modal-content .btn-primary, 
              .modal-content .btn-info,
              .modal-content .btn-light-primary,
              .modal-content .btn-light-info {
                transition: all 0.3s ease !important;
              }
              .modal-content .btn-primary,
              .modal-content .btn-info {
                background-color: ${RESERVATION_COLOR} !important;
                border-color: ${RESERVATION_COLOR} !important;
              }
              .modal-content .btn-primary:hover,
              .modal-content .btn-info:hover {
                background-color: ${RESERVATION_COLOR}dd !important;
                border-color: ${RESERVATION_COLOR}dd !important;
              }
              .modal-content .btn-light-primary,
              .modal-content .btn-light-info {
                background-color: ${RESERVATION_COLOR}15 !important;
                color: ${RESERVATION_COLOR} !important;
                border-color: transparent !important;
              }
              .modal-content .btn-light-primary:hover,
              .modal-content .btn-light-info:hover {
                background-color: ${RESERVATION_COLOR}25 !important;
                color: ${RESERVATION_COLOR} !important;
              }
              .modal-content .text-primary,
              .modal-content .text-info {
                color: ${RESERVATION_COLOR} !important;
              }
              .modal-content .bg-primary,
              .modal-content .bg-info {
                background-color: ${RESERVATION_COLOR} !important;
              }
              .modal-content .bg-light-primary,
              .modal-content .bg-light-info {
                background-color: ${RESERVATION_COLOR}15 !important;
              }
              .modal-content .border-primary,
              .modal-content .border-info {
                border-color: ${RESERVATION_COLOR} !important;
              }
              .modal-content .badge-light-primary,
              .modal-content .badge-light-info {
                background-color: ${RESERVATION_COLOR}15 !important;
                color: ${RESERVATION_COLOR} !important;
              }
            `}
            </style>
            <Modal.Header closeButton className="border-0 px-10 pt-8 pb-0">
              <Modal.Title className="w-100">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <span
                      className={`btn btn-icon btn-sm btn-light-${
                        this.getModalMode() === "update"
                          ? "warning"
                          : this.getModalMode() === "delete"
                          ? "danger"
                          : "info"
                      } mr-4 no-hover`}
                      style={{
                        cursor: "default",
                        width: "35px",
                        height: "35px",
                      }}
                    >
                      <i
                        className={`${
                          this.getModalMode() === "update"
                            ? "fas fa-edit"
                            : this.getModalMode() === "delete"
                            ? "fas fa-trash-alt"
                            : "fas fa-plus"
                        } font-size-sm`}
                      ></i>
                    </span>
                    <h3 className="font-weight-boldest text-dark mb-0 font-size-h4">
                      {this.getModalMode() === "update"
                        ? "Update Reservation"
                        : this.getModalMode() === "delete"
                        ? "Cancel Reservation"
                        : "Add Reservation"}
                    </h3>
                  </div>
                </div>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Container fluid>
                <SmartReservationForm
                  values={values}
                  isAdding={isAdding}
                  isDeleting={isDeleting}
                  loadingTables={loading}
                  selected_reservation={selected_reservation}
                  allTimeSlots={allTimeSlots}
                  tablesForSelectedTime={tablesForSelectedTime}
                  uniqueExperiences={uniqueExperiences}
                  selectedTable={selectedTable}
                  monthlyReservations={monthlyReservations}
                  withPaymentLink={withPaymentLink}
                  RESERVATION_COLOR={RESERVATION_COLOR}
                  inputActions={inputActions}
                  handlers={{
                    getTableUniqueExperience: this.getTableUniqueExperience,
                    handleDateChange: this.handleDateChange,
                    handlePartySizeChange: this.handlePartySizeChange,
                    handlePillClick: this.handlePillClick,
                    handleCreateReservation: this.handleCreateReservation,
                    handleCancelReservation: this.handleCancelReservation,
                    fetchCalendarReservations: this.fetchCalendarReservations,
                    formatDateForInput: (d) => moment(d).format(DB_DATE_FORMAT),
                    handleReservationSelect: this.handleReservationSelect,
                    handleDietaryPillClick: this.handleDietaryPillClick,
                    handleUpdateDietaryCount: this.handleUpdateDietaryCount,
                    handleAddCustomDietaryItem: this.handleAddCustomDietaryItem,
                    handleCelebrationPillClick: this.handleCelebrationPillClick,
                    handleExclusiveExperiencePillClick:
                      this.handleExclusiveExperiencePillClick,
                    handleAddCustomCelebrationItem:
                      this.handleAddCustomCelebrationItem,
                    handlewithPaymentLinkChange:
                      this.handlewithPaymentLinkChange,
                    handleResendEmail: this.handleResendEmail,
                    handleAddAdditional: this.handleAddAdditional,
                    handleRemoveAdditional: this.handleRemoveAdditional,
                  }}
                />
              </Container>
            </Modal.Body>
          </Modal>
        )}
        {selectedGuestForModal && (
          <GuestInformationModal
            show={showGuestInfoModal}
            onHide={() =>
              this.setState({
                showGuestInfoModal: false,
                selectedGuestForModal: null,
              })
            }
            guestId={selectedGuestForModal._id}
            api={this.api}
            onReservationClick={this.onGuestReservationClick}
          />
        )}

        <div
          className="d-flex flex-row"
          style={{ height: "calc(100vh - 200px)" }}
        >
          <ReservationsList
            store_id={store_id}
            api={this.api}
            selected_date={selected_date}
            onReservationClick={this.onReservationClick}
            storeName={store_name}
            onDateInputChange={this.onDateInputChange}
            refresh={refresh_list}
            onTabChange={this.onTabChange}
            onListTabChange={this.onListTabChange}
            onGuestReservationClick={this.onGuestReservationClick}
            {...this.props}
            {...this.state}
          />
          {!isFullWidthView && (
            <div
              className="d-flex flex-column ml-5"
              style={{ flexBasis: "80%" }}
            >
              {!selected_reservation && (
                <ReservationsCalendarHeader
                  store_id={store_id}
                  selected_date={selected_date}
                  onCalendarBtnClick={this.onCalendarBtnClick}
                  onDateInputChange={this.onDateInputChange}
                  onDayClick={this.onDayClick}
                  onStatusChange={this.onStatusChange}
                  onReservationClick={this.onReservationClick}
                  onEditReservationSubmit={this.onEditReservationSubmit}
                  onRefreshList={this.onRefreshList}
                  handleResendEmail={this.handleResendEmail}
                />
              )}
              <ReservationsSeatMap
                selected_reservation={selected_reservation}
                selected_customer={selected_customer}
                isReservationDetails={isReservationDetails}
                onDetailsCloseClick={this.onDetailsCloseClick}
                guest_tags={guest_tags}
                onAddNotesClick={this.onAddNotesClick}
                reservation_notes={reservation_notes}
                onEditCelebrationClick={this.onEditCelebrationClick}
                onEditDietaryClick={this.onEditDietaryClick}
                onAddTags={this.onAddTags}
                onEditReservationClick={this.onEditReservationClick}
                onStatusChange={this.onStatusChange}
                onNoteUpdate={this.onNoteUpdate}
                onNoteDelete={this.onNoteDelete}
                onPrintBtnClick={() => console.log("Print Clicked")}
                onCustomerNameClick={this.onCustomerNameClick}
              />
            </div>
          )}
        </div>
      </>
    );
  }
}

const ReservationsSeatMap = (props) => {
  const {
    selected_customer,
    selected_reservation,
    isReservationDetails,
    onDetailsCloseClick,
    guest_tags,
    onAddNotesClick,
    reservation_notes,
    onEditCelebrationClick,
    onEditDietaryClick,
    onAddTags,
    onEditReservationClick,
    onStatusChange,
    onNoteUpdate,
    onNoteDelete,
    onPrintBtnClick,
    onCustomerNameClick,
  } = props;

  return (
    <Card className="w-100 h-100">
      <Card.Body className="p-0">
        {isReservationDetails ? (
          <ReservationsDetails.DetailsContainer
            customer={selected_customer}
            reservation={selected_reservation}
            onDetailsCloseClick={onDetailsCloseClick}
            guest_tags={guest_tags}
            onAddNotesClick={onAddNotesClick}
            reservation_notes={reservation_notes}
            onEditCelebrationClick={onEditCelebrationClick}
            onEditDietaryClick={onEditDietaryClick}
            onAddTags={onAddTags}
            onEditReservationClick={onEditReservationClick}
            onStatusChange={onStatusChange}
            onNoteUpdate={onNoteUpdate}
            onNoteDelete={onNoteDelete}
            onPrintBtnClick={onPrintBtnClick}
            onCustomerNameClick={onCustomerNameClick}
          />
        ) : (
          <div className="d-flex flex-column justify-content-center align-items-center h-100">
            <SVG
              className="h-100px"
              src={toAbsoluteUrl("/media/svg/illustrations/bg-4.svg")}
            />
            <span
              className="font-pickup-lg font-weight-bolder"
              style={{ color: RESERVATION_COLOR }}
            >
              Select a reservation to view details.
            </span>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};
